import { useMutation } from '@tanstack/react-query';
import { getAppConfig } from '../../../config';
import { loadCredentials } from '../../../apiClient';

type TranscribeResponse = {
  transcript: string;
  confidence: number;
  durationSeconds: number;
};

export function useTranscribeAudio(organizationId: string | undefined) {
  return useMutation({
    mutationFn: async (audioBlob: Blob): Promise<TranscribeResponse> => {
      const { idToken } = loadCredentials();
      const formData = new FormData();
      formData.append('audio', audioBlob, 'recording.webm');

      const response = await fetch(
        `${getAppConfig().apiUrl}/ai-assistant/transcribe`,
        {
          method: 'POST',
          headers: {
            authorization: idToken,
            'x-organization-id': organizationId!,
          },
          body: formData,
        },
      );

      if (!response.ok) {
        const body = await response.json().catch(() => null);
        throw new Error(body?.message || `Transcription failed (${response.status})`);
      }

      return response.json();
    },
  });
}
